import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
// import Dashboard from '../components/Menu/Dashboard';
import { Button, FormControl, Grid, InputLabel, MenuItem, Select, makeStyles /*Container, Typography*/ } from '@material-ui/core';
import LoadingScreen from '../components/Complements/LoadingScreen';
import { feathersCreateData } from '../services';
import Footer from '../components/Complements/Footer';
import { sendMobile } from '../functions/mobile';
import moment from 'moment';
import GenerateQrReduxForm from '../components/QR/FormGenerateQr';
import { urlQr } from '../services/urls';
// import { isMobile } from 'react-device-detect';

const useStyles = makeStyles((theme) => ({
    divStandard: {
      padding: 16, background: theme.palette.type === 'dark' ? '#4a4a4a' : '#fafafa', borderRadius: 15
    }
}));

const QrGeneratesContainer = (props) => {
  const { balances, handleOpenSnack, devices } = props
  const { mac } = devices
  const [loading, setLoading] = useState(false)
  const [showQr, setShowQr] = useState(false)
  const [qrFile, setQrFile] = useState(`data:image/png;base64,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`)
  const [document, setDocument] = useState('')
  const [accountSelected, setAccountSelected] = useState(balances[0])
  const refImage = useRef(null);
  const classes2 = useStyles()

  const handleGenerateQr = async (values) => {
    setLoading(true);
    try {
      // console.log('Cuenta seleccionada antes de la llamada:', accountSelected);
      const responseData = await feathersCreateData('generate-qr-for-transfers', {
        accountNumber: accountSelected.PRODUCTBANKID,
        nameQr: values.alias,
        emailQr: values.email,
        typeAccount: accountSelected.PRODUCTALIAS,
        productTypeId: accountSelected.PRODUCTTYPEID
      })();
      // console.log('Respuesta del servidor:', responseData);
      if (responseData.errors === false) {
        setShowQr(true);
        setQrFile(responseData.data.qr);
        setDocument(responseData.data.documentToPrint);
      }
      handleOpenSnack(responseData.message, responseData.error);
      setLoading(false);
    } catch (error) {
      console.error('Error al generar el QR:', error);

      setLoading(false);
      handleOpenSnack('No se ha podido generar QR', 'error');
    }
  }

  const handleMaskNumberAccount = (numberBeneficiary) => {
    if (numberBeneficiary && numberBeneficiary.length > 4) {
      let resultConvert = "";
      const [a, b, ...dataConvert] = numberBeneficiary;
      const inicioFin = dataConvert.length - 2;
      const ultimos = dataConvert.join('').slice(inicioFin, dataConvert.length);
      for (let y = 0; y < inicioFin; y++) {
        resultConvert = resultConvert.concat("X");
      }
      resultConvert = a + b + resultConvert + ultimos;
      return resultConvert;
    } else {
      return numberBeneficiary;
    }
  }

  const handlePrintProcess = () => {
    try {
      const { mac } = devices;
      if (mac !== "NAVEGADOR") {
        let send = {
          type: 'action',
          action: 'export_voucher',
          data: urlQr + `${document}`,
          nameFile: 'QR_PAY_' + moment().format("DDMMYYYYHHmmss"),
          extension: 'pdf',
          messageSend: 'Pago QR'
        }
        sendMobile(JSON.stringify(send))
      } else {
        handlePrint()
      }
    } catch (error) {
      // console.log(error)
    }
  }

  const handleGenerateQrReset = () => {
    setShowQr(false);
  }

  const handlePrint = () => {
    window.open(urlQr + document, '_blank');
  }


  const renderBody = () => {
    //console.log(balances, 'balances')
    return <div style={{
      padding: "20px",
      borderRadius: "15px",
    }}>
      <Grid container alignContent='center' alignItems='center' justifyContent='center' style={{ gap: 16, margin: 'auto' }} xs={12} sm={12} md={6}>
        {!showQr ? <div className={classes2.divStandard}>
          <Grid item xs={12} md={12} lg={12} sm={12} style={{ padding: "20px 0", textAlign: 'center' }}>
            <img src={process.env.PUBLIC_URL + 'icons/isotipo_solpay.svg'} width={'80%'} alt='qr'/>
          </Grid>
          <Grid container alignContent='center' alignItems='center' justifyContent='center' >
            <Grid item xs={12} md={12} lg={12} sm={12}>
              <FormControl variant="outlined" fullWidth>
                <InputLabel id="demo-simple-select-outlined-label">Seleccione una Cuenta</InputLabel>
                <Select
                  label="Seleccione una Cuenta"
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  defaultValue={accountSelected}
                  onChange={(e) => { setAccountSelected(e.target.value); setShowQr(false) }} >
                  {
                    balances.map(option => (
                      <MenuItem key={option.PRODUCTBANKID} value={option}>
                        <div >
                          {`${handleMaskNumberAccount(option.PRODUCTBANKID)} - ${option.PRODUCTALIAS}`}
                        </div>
                      </MenuItem>
                    ))
                  }
                </Select>
              </FormControl>
            </Grid>
            <br />
            <br />
            <Grid item xs={12} md={12} lg={12} sm={12}>
              <GenerateQrReduxForm
                onSubmit={handleGenerateQr}
              />
            </Grid>
          </Grid>
        </div>
          :
          <Grid container spacing={3} alignItems="center" direction="row" justify="center">

            {/* <img src={process.env.PUBLIC_URL + '/images/logo_movil_cl.png'} alt="Logo" /> */}
            <Grid item xs={12} md={12}>
              <p style={{ textAlign: "center" }}>
                Muestra este código para que puedan pagarte.
              </p>
            </Grid>
            <Grid style={{
              width: '100%',
              position: 'relative',
              marginBottom: 16
            }}>
              <img src={process.env.PUBLIC_URL + '/icons/fondo_qr.png'} alt="QR Generate" ref={refImage} style={{ width: '100%', height: 'auto', display: 'block', borderRadius: 15 }} />
              <img src={qrFile} alt="QR Generate" ref={refImage} style={{ width: '75%', position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }} />
            </Grid>
            <Grid container spacing={2} alignItems="center" direction="row" justifyContent="center">
              <Grid item xs={6} md={6} lg={6} sm={6}>
                <Button variant="outlined" color='primary' fullWidth onClick={handlePrintProcess}>
                  {mac === "NAVEGADOR" ? 'Imprimir' : 'Compartir'}
                </Button>
              </Grid>
              <Grid item xs={6} md={6} lg={6} sm={6}>
                <Button variant="contained" color='primary' fullWidth onClick={handleGenerateQrReset}>
                  Generar
                </Button>
              </Grid>
            </Grid>
          </Grid>
        }


      </Grid>
    </div>
  }

  return (
    <div>
      {/* <Dashboard
        title="Dashboard"
        body={renderBody()}
        multiple={false}
      /> */}
      {renderBody()}
      <Footer />
      <LoadingScreen open={loading} />
    </div>
  );
};

QrGeneratesContainer.propTypes = {
  balances: PropTypes.array.isRequired
};

export default QrGeneratesContainer;
